/**
 * Height cap shared by the overview tables. It is what makes a table scroll inside its own
 * container, and that is what keeps its sticky header on screen: an unbounded container never
 * scrolls itself, so the header simply leaves with the page.
 *
 * The numbers come from the page shell, which is a fixed 100vh: the nav (80px, 64px above 1025px),
 * the 1rem top padding of the content row, and the 40px the content reserves for the fixed footer.
 * That leaves 100vh - 136px of actually visible scrolling area.
 *
 * From md up the filters fit above the table, so the cap leaves room for them and nothing scrolls.
 * Below that the filters stack and are far too tall for that, so the table takes the whole visible
 * area instead and the filters scroll away above it. Either way the container is never taller than
 * the area it scrolls in, which is what keeps its top edge - and the header stuck to it - in view.
 */
export const overviewTableMaxHeightSx = {
  maxHeight: { xs: "calc(100vh - 136px)", md: "calc(100vh - 260px)" },
  // Fullscreen drops the nav, the sidebar and the page padding; only the filters sit above.
  ".fullscreen &": { maxHeight: "calc(100vh - 140px)" },
};
